import dateformat from 'dateformat';
export function parseReviewURLToStoreConfig(searchString: string) {
    return {};
}
export function prepareBookingKey(params) {
    const { src, dest, src_vid, dest_vid, doj, seats, routeId, bpDetail, dpDetail } = params;
    let id = ""
    const splitList = routeId.split('@');
    if (splitList.length > 1) {
        id = splitList[1];
    } else {
        id = splitList[0];
    }

    //  booking-key=bus-Bangalore-Chennai-20200630--1-0-0-6771549831164675055-4354390963378411938-1000002134681472942-21131520-02-
    let bookingKey = `bus-${src}-${dest}-${doj}--${seats.length}-0-0-${src_vid}-${dest_vid}-${id}${(bpDetail && bpDetail.id) ? `-${bpDetail.id}` : ''}${(dpDetail && dpDetail.id) ? `-${dpDetail.id}` : ''}-${seats.join("-")}`;

    return bookingKey;
}

export function prepareQueryData(params) {
    const { src, dest, doj, seats, src_vid, dest_vid } = params;
    //     querydata:'#bus-Delhi-Chandigarh-20200610--2-0-0-2820046943342890302-1490240556082995568',
    const str = `#bus-${src}-${dest}-${doj}--${seats.length}-0-0-${src_vid}-${dest_vid}`;
    return str;
}
export function prepareBookingData(params) {
    const { selectedSeatsData, routeId, journeyType, bpDetail, dpDetail, fd, redDealsDiscount, cat_card_selected, busData, bps, dps, page_source } = params;
    let bookingData = [{
        "BPName": bpDetail ? bpDetail.name : '',
        "DPName": dpDetail ? dpDetail.name : '',
        "bp": bpDetail ? bpDetail.name : '',
        "dp": dpDetail ? dpDetail.name : '',

        "rt": journeyType,
        "routeID": routeId,
        "fd": fd,
        boardingpoints: bps,
        droppingpoints: dps,
        "seatsSelected": selectedSeatsData,
        "ss": selectedSeatsData,
        ...busData,
        page_src: page_source || ''
    }

    ];

    if (redDealsDiscount && Object.keys(redDealsDiscount).length) {

        bookingData[0]['redDealsDiscount'] = redDealsDiscount;
    }

    if (cat_card_selected && Object.keys(cat_card_selected).length) {

        bookingData[0]['cat_card_selected'] = cat_card_selected;
    }
    return bookingData;
}

export function getReviewPageURL(params) {
    const { bookingKey, routeId, querydata, token, page_source, is_sponsored, is_bo_ads } = params;

    return `/bus/review/?is_sponsored=${is_sponsored}&is_bo_ads=${is_bo_ads}&bookingKey=${bookingKey}&token=${token ? token : ''}&routeId=${routeId}&querydata=${querydata}${page_source ? `&page_source=${page_source}` : ''}`
}

export function getOldReviewPageURL(params) {
    const { bookingKey, routeId, querydata, token } = params;
    return `/bus-booking/?vc=v5&booking-key=${bookingKey}&from=SRPSuperBus`
}

export function getJourneyDetails(data) {
    const { origin, destination, depdate, reviewPersuasion } = data;
    const doj = dateformat(new Date(depdate.split('T')[0]), 'dS mmmm yyyy');
    const persuasionText = reviewPersuasion.text;
    return { src: origin, dest: destination, doj, persuasionText };
}

export const getCookie = (cname) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
